export const defaultBorderRadius = '0.625rem'
